import {HeartRate} from '../../../Domain/HeartRate';

export function formatHeartRate(heartRate: HeartRate | null): {formatted: string; unit?: string} {
    if (heartRate === null) {
        return {formatted: ''};
    }
    return {formatted: heartRate.bpm.toFixed(0), unit: 'bpm'};
}

export function formatAverageHeartRate(heartRate: HeartRate | null): {formatted: string; unit?: string} {
    if (heartRate === null) {
        return {formatted: ''};
    }
    return {formatted: heartRate.bpm.toFixed(1), unit: 'bpm'};
}
